<template>
  <div class="zj-layout-main-content bgcolor scrollable" style="overflow: auto;">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="110px">
      <zj-layout-container>
        <zj-layout-header>
          <div class="listtitle">客流区域阈值设置详情</div>
        </zj-layout-header>
      </zj-layout-container>
      <!-- prop="ResourceName" -->
      <zj-layout-main>
        <el-form ref="form" :model="data" :rules="rules" label-width="16rem" style="width: 80%;">
          <el-row>
            <el-col :span="12">
              <el-form-item label="区域" prop="RegionId">
                <el-select
                  v-model="data.RegionId"
                  :disabled="!IsEdit"
                  placeholder="请选择"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in EqRegionArr"
                    :key="item.RegionId"
                    :label="item.RegionName"
                    :value="item.RegionId"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="报警阈值" prop="WarmThreshold">
                <el-input v-model="data.WarmThreshold" type="number" :disabled="!IsEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="预警阈值" prop="Threshold">
                <el-input v-model="data.Threshold" type="number" :disabled="!IsEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </zj-layout-main>
      <el-form-item class="right" style="width:134rem;">
        <el-button @click="onBack()">返回</el-button>
        <el-button type="primary" @click="saveForm()" :disabled="!IsEdit" v-if="IsEdit">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import MyApis from "../../../apis";
import ZJApp from "../../../../../app";

export default {
  name: "RegionThresholdConfigEdit",
  controller: "UI",
  action: "RegionThresholdConfigEdit",
  data() {
    return {
      data: {
        RegionId: ""
      },
      IsEdit: false,
      EqRegionArr: [],
      rules: {
        RegionId: [{ required: true, message: "请选择区域", trigger: "change" }],
        WarmThreshold:[{ required: true, message: "请输入报警阈值", trigger: "blur" }],
        Threshold:[{ required: true, message: "请输入预警阈值", trigger: "blur" }],
      }
    };
  },
  created: function() {
    if (this.$route.query.InfoId) {
      this.search();
    }
    if (this.$route.query.type == "query") {
      this.IsEdit = false;
    } else {
      this.IsEdit = true;
    }
    //区域
    this.getRegionInfo();
  },
  watch: {
    $route: function() {
      if (this.$route.query.InfoId) {
        this.search();
      }
    }
  },
  methods: {
    getRegionInfo() {
      const RegionInfo = {
        EquipmentType: "Monitor",
        Longitude: 0.0,
        Latitude: 0.0
      };
      new MyApis.RegionList()
        .GetRegionInfos(RegionInfo)
        .then(r => {
          r = r.data.Data;
          this.EqRegionArr = r;
        })
        .catch(e => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    search() {
      let InfoId = this.$route.query.InfoId;
      if (InfoId) {
        new MyApis.RegionThresholdApi()
          .GetItemById({ Id: InfoId })
          .then(r => {
            r = r.data.Data;
            console.log(r);
            this.data = r;
          })
          .catch(e => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    //保存
    saveForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.saveData();
        } else {
          return false;
        }
      });
    },
    saveData() {
      // let uuid = "";
      // if (this.$route.query.type == "edit") {
      //   uuid = this.$route.query.InfoId;
      // } else {
      //   uuid = ZJApp.ZJUtils.uuid();
      // }
      if (this.data.RegionId != null && this.data.RegionId != "") {
        const RegionName = this.EqRegionArr.filter(item => {
          return item.RegionId === this.data.RegionId;
        });
        this.data.RegionName = RegionName[0].RegionName;
      }
      this.data.WarmThreshold = parseInt(this.data.WarmThreshold);
      this.data.Threshold = parseInt(this.data.Threshold);
      if (this.$route.query.type == "edit") {
        //编辑
        this.Edit();
      } else {
        // 增加
        this.getRegionThresholdData();
      }
    },
    getRegionThresholdData() {
      let searchInfo = {
        RegionId: this.data.RegionId
      };
      return new MyApis.RegionThresholdApi()
        .FindByConditions(searchInfo)
        .then(r => {
          r = r.data.Data;
          debugger;
          
          if (r.length > 0) {
            this.$message({
              type: "warning",
              message: "该区域已维护阈值信息"
            });
          } else {
            this.Add();
          }
        })
        .catch(e => {
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    Edit() {
      //编辑
      this.data.ModifyTime = new Date();
      this.data.Modifier = ZJApp.ZJUser.current.UserName;
      let formAll = JSON.stringify(this.data);
      formAll = JSON.parse(formAll);
      new MyApis.RegionThresholdApi()
        .UpdateItem(formAll)
        .then(r => {
          r = r.data.Data;
          this.$message({
            type: "success",
            message: r ? "保存成功！" : "保存失败！"
          });
          this.$router.go(-1); //返回上一层
        })
        .catch(e => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    Add(){
       // 增加
        let formObj = {
          Creater: ZJApp.ZJUser.current.UserName,
          CreateTime: new Date(),
          Modifier: ZJApp.ZJUser.current.UserName,
          ModifyTime: new Date(),
          Validity: 1 //新增编辑是1，删除是0
        };
        let formAll = Object.assign(formObj, this.data);
        formAll = JSON.stringify(formAll);
        formAll = JSON.parse(formAll);
        new MyApis.RegionThresholdApi()
          .AddItem(formAll)
          .then(r => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！"
            });
            this.$router.go(-1); //返回上一层
          })
          .catch(e => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
    }
  }
};
</script>
